<template>
  <div class="login">
    <div class="contents">
      <div class="login-base">
        <p class="reset-title">忘记密码？</p>
        <p class="reset-title-lable">请填写您要找回的账号信息</p>
        <div class="login-by-phone">
          <el-form ref="form" :rules="rules" :model="form">
            <el-form-item prop="username">
              <el-input
                AUTOCOMPLETE="off"
                v-model="form.username"
                placeholder="手机号/邮箱"
                auto-complete="new-password"
              >
                <i
                  slot="prefix"
                  class="el-input__icon icon iconfont icon-youxiang1"
                ></i>
              </el-input>
            </el-form-item>
            <el-form-item class="form-item" prop="code">
              <el-input
                v-model="form.code"
                placeholder="请输入验证码"
                auto-complete="new-password"
              >
                <div
                  class="verification-class"
                  v-if="isShow"
                  @click="verification"
                  slot="append"
                >
                  获取验证码
                </div>
                <div v-else slot="append">{{ count }}秒后再获取</div>
                <i
                  slot="prefix"
                  class="el-input__icon icon iconfont icon-renzhengguanli"
                ></i>
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="onSubmit('form')"
                class="loginbutton"
                >提&nbsp;交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    var validatorUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("账号不能为空"));
      } else if (
        !(
          /^1\d{10}$/.test(value) ||
          /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/.test(value)
        )
      ) {
        callback(new Error("账号格式错误"));
      } else {
        callback();
      }
    };
    return {
      form: {
        username: "",
        code: "",
      },
      usertype: 1,
      rules: {
        username: [
          { required: true, validator: validatorUsername, trigger: "blur" },
        ],
        code: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
      },
      isShow: true,
      count: 0,
      visShow: false,
    };
  },
  metaInfo() {
    return {
      title: "Movibot官网_工业机器人上下游供应链",
      meta: [
        {
          name: "keywords",
          content:
            "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案",
        },
        {
          name: "description",
          content:
            "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人,智能家庭及商业应用,仓储物流,食品行业,医药行业,汽车行业,机械设备制造,电子行业提供工业自动化设备和行业解决方案",
        },
      ],
    };
  },
  methods: {
    filedCheck(prop) {
      let noSave = false;
      this.$refs.form.validateField(prop, (valid) => {
        if (valid) {
          noSave = true;
        }
      });
      return noSave;
    },

    onSubmit() {
      const validateFieldList = Object.keys(this.rules);
      const noSave = validateFieldList.some((i) => this.filedCheck(i));
      if (!noSave) {
        // 调用保存接口
        this.dataFormSubmit();
      }
    },

    dataFormSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.findPassword();
        } else {
          return false;
        }
      });
    },
    onSuccess(msg) {
      this.visShow = false;
      //可以在此加上axios或其他代码
    },
    onClose() {
      this.visShow = false;
    },
    verification() {
      this.sendCode();
    },
    countdown() {
      this.isShow = false; //倒计时
      this.count = 60; //赋值60秒
      var times = setInterval(() => {
        this.count--; //递减
        if (this.count <= 0) {
          // <=0 变成获取按钮
          this.isShow = true;
          clearInterval(times);
        }
      }, 1000); //1000毫秒后执行
    },
    //发送验证码
    sendCode() {
      let info = {};
      var reg_tel3 = /^1\d{10}$/;
      if (reg_tel3.test(this.form.username)) {
        info.phone = this.form.username;
        //手机号
        this.usertype = 1;
        this.$api.user.sendCode(info).then((res) => {
          if (res.data.errno == 0) {
            this.$FUnitls.showInfo("发送成功", "info");
            this.countdown();
          } else {
            this.$FUnitls.showInfo(res.data.msg, "info");
          }
        });
      } else if (
        /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/.test(
          this.form.username
        )
      ) {
        info.mail = this.form.username;
        this.usertype = 2;
        //邮箱
        this.$api.user.sendMailCode(info).then((res) => {
          if (res.data.errno == 0) {
            this.$FUnitls.showInfo("发送成功", "info");
            this.countdown();
          } else {
            this.$FUnitls.showInfo(res.data.msg, "info");
          }
        });
      } else {
        this.$FUnitls.showInfo("请输入正确的账号", "info");
      }
    },
    tologin() {
      this.$router.push({ name: "login" });
    },

    findPassword() {
      let info = {};
      info.type = this.usertype;

      if (info.type == 1) {
        info.phone = this.form.username;
      } else {
        info.mail = this.form.username;
      }
      info.code = this.form.code;

      this.$api.user.passwordMail(info).then((res) => {
        if (res.data.errno == 0) {
          this.$router.push({
            name: "resetpassword",
            params: { code: res.data.datas.idCode },
          });
        } else {
          this.$FUnitls.showInfo(res.data.errmsg, "error");
        }
      });
    },
  },
};
</script>
<style  scoped>
.login {
  position: relative;
  width: 100%;
  height: 750px;
  background: url("/static/login/loginbj.png") no-repeat center top;
}
.login-base {
  position: absolute;
  right: 0;
  top: 170px;
  width: 380px;
}
.contents{
  margin: 0 auto;
  position: relative;
}
.ruleurlbox {
  color: #666666;
  font-size: 14px;
  margin-left: 5px;
}
.ruleurlbox a {
  color: #0464cd;
}
/* .icon-shouji {
  color: #0464cd;
} */
.form-item {
  position: relative;
  margin-bottom: 45px;
}
.register-line {
  text-align: center;
  font-size: 16px;
  color: #666;
}
.register-line .register {
  color: #0464cd;
}
.reset-title {
  font-size: 24px;
  color: #116cd0;
  margin-bottom: 10px;
}
.reset-title-lable {
  font-size: 14px;
  color: #ff3434;
  margin-bottom: 15px;
}
.verification-class {
  cursor: pointer;
}
.login-by-phone >>> input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #c7c6c6 inset !important;
  -webkit-text-fill-color: #ededed !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s;
  -webkit-text-fill-color: #666 !important;
}

.login-by-phone >>> .el-input--prefix .el-input__inner {
  color: #666;
  font-size: 16px;
  padding-left: 50px;
  border: none;
  border-bottom: 1px solid #e6e6e6;
  height: 54px;
  line-height: 54px;
  border-radius: 0;
}

.login-by-phone >>> .el-form-item.is-error .el-input__inner,
.login-by-phone >>> .el-form-item.is-error .el-input__inner:focus {
  border: none;
  border-bottom: 1px solid #e6e6e6;
}

.login-by-phone >>> .el-input--prefix .iconfont.icon-youxiang1 {
  font-size: 26px;
}
.login-by-phone >>> .el-input-group__append,
.login-by-phone >>> .el-input-group__prepend {
  border: none;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  color: #0464cd;
}
.login-by-phone >>> .el-input__prefix .iconfont.icon-renzhengguanli {
  font-size: 26px;
}
.login-by-phone >>> .el-input__prefix {
  padding-top: 2px;
}
.login-by-phone >>> .el-input__prefix .iconfont {
  color: #0464cd;
  font-size: 20px;
}
.login-by-phone >>> .loginbutton {
  width: 100%;
  font-size: 20px;
}
.login-by-phone >>> .el-checkbox__label {
  color: #fff;
}
.login-by-phone >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
}
.login-by-phone >>> .el-button {
  border-radius: 26px;
}
.login-by-phone >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.login-by-phone >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner,
.login-by-phone >>> .el-checkbox__inner {
  border-radius: 7px !important;
}
</style>
</style>



// WEBPACK FOOTER //
// src/views/user/find.vue